import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Typography, Box } from "@mui/material/";
import { makeStyles } from "@mui/styles";

import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./MessageBoard.css";

import { HashLink } from "react-router-hash-link";
import Menu from "./Menu";
import { collection, query, setDoc, doc, getDoc, db } from "../../firebase";

const MessageBoardDetail = () => {
  const { t, i18n } = useTranslation();
  let { id } = useParams();
  const [board, setBoard] = useState([]);
  console.log("board", board);

  useEffect(() => {
    setBoard([]);
    window.scrollTo(0, 0);
    getBoards();
  }, []);

  const getBoards = async () => {
    const docRef = doc(db, "board", id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      console.log("Document data:", docSnap.data());
      setBoard(docSnap.data());
      setDoc(docRef, { viewed: docSnap.data().viewed + 1 }, { merge: true });
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
    }
  };

  return (
    <Grid container sx={{ py: 6, width: 1, display: "flex" }}>
      <Menu current="message" />
      <Grid md={10} sm={12} xs={12} item>
        <Box sx={{ px: 7 }}>
          <Box sx={{ fontSize: "22px" }}>
            공지사항{" "}
            <span
              style={{ fontSize: "13px", paddingLeft: "10px", fontWeight: 200 }}
            >
              헤즐릿의 모든 뉴스/공지들을 이곳에서 확인해주세요.
            </span>
          </Box>
          <Box sx={{ fontSize: "12px" }}>
            <Box sx={{ mt: 4, borderTop: "2px solid gray", display: "flex" }}>
              <Box
                sx={{ width: "50px", px: 3, backgroundColor: "#f5f5f5", py: 1 }}
              >
                제목
              </Box>
              <Box sx={{ flex: 1, px: 3, py: 1 }}>{board.title}</Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                borderTop: "1px solid #eeeeee",
                borderBottom: "1px solid #eeeeee",
              }}
            >
              <Box sx={{ width: 1 / 2, display: "flex" }}>
                <Box
                  sx={{
                    width: "50px",
                    px: 3,
                    backgroundColor: "#f5f5f5",
                    py: 1,
                  }}
                >
                  작성일
                </Box>
                <Box sx={{ flex: 1, px: 3, py: 1 }}>
                  {board?.created &&
                    board?.created?.toDate().toLocaleDateString("fr-CA", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })}
                </Box>
              </Box>
              <Box sx={{ width: 1 / 2, display: "flex" }}>
                <Box
                  sx={{
                    width: "50px",
                    px: 3,
                    backgroundColor: "#f5f5f5",
                    py: 1,
                  }}
                >
                  조회수
                </Box>
                <Box sx={{ width: "70%", px: 3, py: 1 }}>
                  {board.viewed + 1}
                </Box>
              </Box>
            </Box>
            <Box sx={{ borderBottom: "1px solid #eeeeee", px: 3, py: 2 }}>
              <Typography dangerouslySetInnerHTML={{ __html: board.message }} />
            </Box>
            <Box sx={{ mt: 2 }}>
              <HashLink smooth to="/message-board">
                <button className="custom_btn" style={{ width: "200px" }}>
                  목록
                </button>
              </HashLink>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default MessageBoardDetail;
